import React, { useState } from "react";
import apiAuth from "../../helpers/ApiAuth";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Row,
  Col,
} from "reactstrap";

function ProductList() {
  const [products, setProducts] = useState([
    { id: 1, name: "Laptop", price: "1000" },
    { id: 2, name: "Mobile", price: "1500" },
    { id: 3, name: "Tab", price: "2500" },
  ]);

  const paymentHandler = (item) => {
    const planId = {
      plan_id: item.id,
    };

    apiAuth
      .post("/api/checkout-session/", planId)
      .then((response) => {
        const url = response.data.url;
        window.location.replace(url);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className="py-5 my-5 px-5">
      <h2 className="py-3">Product List</h2>
      <Row>
        <Col lg={12}>
          <div className="d-flex gap-2">
            {products.map((product) => (
              <Card key={product.id}>
                <CardBody>
                  <CardTitle>
                    <strong>{product.name}</strong>
                  </CardTitle>
                  <CardText>Price: ${product.price}</CardText>
                  <Button
                    color="primary"
                    onClick={() => paymentHandler(product)}
                  >
                    Buy Now
                  </Button>
                </CardBody>
              </Card>
            ))}
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default ProductList;
